import Backbone from 'backbone';
import ControlView from './ControlView';

export default Backbone.View.extend({
  initialize(o) {
    let config = o.config;
    this.gconfig = o.gconfig;
    this.config = config;
    this.em = config.em;
    this.render();
  },

  events: {
    'click .add-new-control': 'addNewControl'
  },

  template() {
    return `<div class="add-new-control"><div class="inner-box">+</div></div>`;
  },

  addNewControl() {
    editor.studioPlugin.addControl();
  },

  addToCollection(model, fragmentEl) {
    var fragment = fragmentEl || null;
    var viewObject = ControlView;

    var view = new viewObject({
      model,
      parent: this,
      config: this.config,
      gconfig: this.gconfig
    });
    var rendered = view.render().el;

    if (fragment) {
      fragment.appendChild(rendered);
    } else {
      this.$el.append(rendered);
    }
    return rendered;
  },

  render() {
    this.is_rendering = true;
    var fragment = document.createDocumentFragment();
    this.$el.empty();
    this.collection.each(function(model) {
      this.addToCollection(model, fragment);
    }, this);
    this.$el.append(this.template());
    this.$el.append(fragment);
    this.$el.addClass('ctrl_item_wrapper');
    this.is_rendering = false;
    return this;
  }
});
